/** Minúsculas, sin acentos y con los espacios colapsados: «Régimen» encuentra «regimen». */
export const normalizeSearch = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

/** «626 - Régimen Simplificado de Confianza» → «Régimen Simplificado de Confianza». */
export const stripCodePrefix = (name: string) => name.replace(/^\S+\s-\s/, '');

/**
 * Busca por nombre o RFC sin acentos, mayúsculas ni puntuación, palabra por palabra y en
 * cualquier orden: «lopez juan» encuentra a «Juan Pérez López» y «sa de cv» a «… S.A. de C.V.».
 */
export const matchesNameOrRfc = (name: string, rfc: string, query: string): boolean =>
  matchesAnyField([name, rfc], query);

/**
 * La misma búsqueda sobre los campos que se le pasen. Sin puntuación, un UUID se encuentra
 * pegado completo o por un pedazo, con o sin guiones.
 */
export const matchesAnyField = (fields: string[], query: string): boolean => {
  const withoutPunctuation = (text: string) => normalizeSearch(text.replace(/[^\p{L}\p{N}\s]/gu, ''));
  const words = withoutPunctuation(query).split(' ').filter(Boolean);
  if (!words.length) return true;
  const haystack = fields.map(withoutPunctuation).join(' ');
  return words.every((word) => haystack.includes(word));
};
